import axios from "axios";

/**
 * Backend URL resolution.
 *
 * If REACT_APP_BACKEND_URL is set at build time AND matches the current page's
 * origin, we prefer the same-origin relative path `/api` — this avoids CORS
 * headaches when the site is accessed on both `leosluxury.com` and
 * `www.leosluxury.com` (or any other alias). If the env value points to a
 * different origin (dev/preview setups), we fall back to the absolute URL.
 */
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

function resolveApiBase() {
    if (typeof window === "undefined") return `${RAW_BACKEND_URL}/api`;
    try {
        if (!RAW_BACKEND_URL) return "/api";
        const envHost = new URL(RAW_BACKEND_URL).host.replace(/^www\./, "");
        const winHost = window.location.host.replace(/^www\./, "");
        // same site (with or without www) → use same-origin relative path
        if (envHost === winHost) return "/api";
        return `${RAW_BACKEND_URL}/api`;
    } catch {
        return `${RAW_BACKEND_URL}/api`;
    }
}

export const API = resolveApiBase();

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
    const { data } = await api.post("/leads", payload);
    return data;
}

export async function getEstimate(payload) {
    const { data } = await api.post("/estimate", payload);
    return data;
}

export async function getProperties() {
    const { data } = await api.get("/properties");
    return data;
}
